import { REMOVER_FILTRO_EMPRESA } from '../types'

export default function removerFiltroEmpresa (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_EMPRESA
  }
}
